import React from 'react';
//import {  animateScroll as scroll } from 'react-scroll';

import service  from './dataService';


class ThirdPart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showThirdPart: {
        hidden: 'hidden'
      },
    };

    service.onValuesChanged(this.dataCenterDataChange.bind(this));
  }

  dataCenterDataChange(data) {
    this.setState({
      showThirdPart: data.showThirdPart
    });
  }

  imgHandler = (event) => {
    event.preventDefault();
    window.location.href = "https://www.makello.com";
  };

  render() {
      return (
        <div className={`ThirdPart ${service.data.showThirdPart.hidden}`}>
        <div className='App'>
          <div className='main3'>

            <div className='jumbotron text-center bg-white'>
              <h3 className="display-6">Thank you!</h3>
              <p className='lead'>Check for a confirmation email in your Inbox or SPAM folder</p>
              <div>Add us to your Contacts to receive a personalized <a href="https://www.makello.com/energy-analysis.html">Energy Analysis</a> from <a href="https://www.makello.com/">Makello</a>!</div>
              <div>For any questions, please call: (760) 230-3788. </div>
            </div>

            <div className='jumbotron text-center rounded-0 border-0'>
              <div className='row'>
                <div className="col-md-4 offset-md-4">
                  <img className="img-fluid" src="./images/Makello_Flat_Facebook_Profile_180x180.png" alt="makelloLogoNG" onClick={this.imgHandler} />
                </div>
              </div>
              <p><a href="https://www.makello.com">www.makello.com</a></p>
              <p>
                <small className="text-muted">Makello is an authorized distributor for Green Energy EPC (CSLB License #1110498) having 100% 5-Star Recommended Reviews on
                  <a href="https://www.yelp.com/biz/green-energy-epc-san-diego"> Yelp!</a> 141 Reviews Total on Yelp!​​ (4.9 Ave)</small>
              </p>
            </div>

          </div>
        </div>
        </div>
      );

  }
}

export default ThirdPart;